const enterpriseInnerApp = [
  {
    path: 'admin-config',
    name: '',
    component: () => import('@/apps/open/views/fileCenter/components/FileRouter.vue'),
    redirect: 'admin-config/create-app',
    meta: { title: '管理中心配置' },
    children: [{
      path: 'create-app',
      name: '',
      component: () => import('@/apps/open/views/fileCenter/components/FileContent.vue'),
      meta: { title: '应用创建', mdfilepath: '/appconfig/CreateCorpInnerApp.md' }
    },
    {
      path: 'apply-permission',
      name: '',
      component: () => import('@/apps/open/views/fileCenter/components/FileContent.vue'),
      meta: { title: '权限申请', mdfilepath: '/appconfig/ApplyAbility.md' }
    },
    {
      path: 'basic-config',
      name: '',
      component: () => import('@/apps/open/views/fileCenter/components/FileContent.vue'),
      meta: { title: '基本设置', mdfilepath: '/appconfig/BasicConfig.md' }
    },
    {
      path: 'auth-config',
      name: '',
      component: () => import('@/apps/open/views/fileCenter/components/FileContent.vue'),
      meta: { title: '认证配置', mdfilepath: '/appconfig/Authentication.md' }
    },
    {
      path: 'sync-config',
      name: '',
      component: () => import('@/apps/open/views/fileCenter/components/FileContent.vue'),
      meta: { title: '同步配置', mdfilepath: '/appconfig/Synchronization.md' }
    }]
  },
  {
    path: 'authorize',
    name: '',
    redirect: 'authorize/access-know',
    component: () => import('@/apps/open/views/fileCenter/components/FileRouter.vue'),
    meta: { title: '企业授权' },
    children: [{
      path: 'access-know',
      name: '',
      component: () => import('@/apps/open/views/fileCenter/components/FileContent.vue'),
      meta: { title: '接入须知', mdfilepath: '/enterpriseability/authorize/AccessKnow.md' }
    },
    {
      path: 'api-list',
      name: '',
      component: () => import('@/apps/open/views/fileCenter/components/FileContent.vue'),
      meta: { title: 'Api列表', mdfilepath: '/enterpriseability/authorize/InnerApiList.md' }
    },
    {
      path: 'python-sign',
      name: '',
      component: () => import('@/apps/open/views/fileCenter/components/FileContent.vue'),
      meta: { title: '签名说明', mdfilepath: '/enterpriseability/authorize/Signature.md' }
    }]
  },
  {
    path: 'adressbook',
    name: '',
    redirect: 'adressbook/access-know',
    component: () => import('@/apps/open/views/fileCenter/components/FileRouter.vue'),
    meta: { title: '企业通讯录' },
    children: [{
      path: 'access-know',
      name: '',
      component: () => import('@/apps/open/views/fileCenter/components/FileContent.vue'),
      meta: { title: '接入须知', mdfilepath: '/enterpriseability/addressbook/AccessKnow.md' }
    },
    {
      path: 'api-list',
      name: '',
      component: () => import('@/apps/open/views/fileCenter/components/FileContent.vue'),
      meta: { title: 'Api列表', mdfilepath: '/enterpriseability/addressbook/ApiList.md' }
    },
    {
      path: 'ext-api-list',
      name: '',
      component: () => import('@/apps/open/views/fileCenter/components/FileContent.vue'),
      meta: { title: '扩展API列表', mdfilepath: '/enterpriseability/addressbook/ExtApiList.md' }
    }]
  },
  {
    path: 'team',
    name: '',
    redirect: 'team/general',
    component: () => import('@/apps/open/views/fileCenter/components/FileRouter.vue'),
    meta: { title: '企业团队' },
    children: [{
      path: 'general',
      name: '',
      component: () => import('@/apps/open/views/fileCenter/components/FileContent.vue'),
      meta: { title: '普通团队API列表', mdfilepath: '/enterpriseability/team/OrdTeamApiList.md' }
    },
    {
      path: 'department',
      name: '',
      component: () => import('@/apps/open/views/fileCenter/components/FileContent.vue'),
      meta: { title: '部门团队API列表', mdfilepath: '/enterpriseability/team/DepTeamApiList.md' }
    }]
  },
  {
    path: 'msg-subscribe',
    name: '',
    redirect: 'msg-subscribe/callback',
    component: () => import('@/apps/open/views/fileCenter/components/FileRouter.vue'),
    meta: { title: '消息订阅' },
    children: [{
      path: 'callback',
      name: '',
      component: () => import('@/apps/open/views/fileCenter/components/FileContent.vue'),
      meta: { title: '回调API列表', mdfilepath: '/messagetopic/TopicList.md' }
    },
    {
      path: 'go-decode',
      name: '',
      component: () => import('@/apps/open/views/fileCenter/components/FileContent.vue'),
      meta: { title: 'Go解密示例', mdfilepath: '/messagetopic/GoDecode.md' }
    },
    {
      path: 'python-decode',
      name: '',
      component: () => import('@/apps/open/views/fileCenter/components/FileContent.vue'),
      meta: { title: 'Python解密示例', mdfilepath: '/messagetopic/PythonDecode.md' }
    }]
  },
  {
    path: 'demo',
    name: '',
    component: () => import('@/apps/open/views/fileCenter/components/FileContent.vue'),
    meta: { title: 'Demo示例', mdfilepath: '/enterpriseability/Demo.md' }
  }
]

export default enterpriseInnerApp
